module.exports = __webpack_public_path__ + "media/maids/kakusei-a6e7c812.gif";